// The subject is a plain string, so a template's variables are substituted
// when it is applied. What is kept here lets them follow a later change of
// recipients, as the body's markers do at send.
export type TemplateSubject = {
  // The template's subject, variables unresolved.
  raw: string;
  // What the composer last wrote into the field from `raw`. A field that no
  // longer holds it was edited by the agent and is theirs from then on.
  applied: string;
};

export const substituteSubject = (
  raw: string,
  suggestionsMap: Record<string, string>,
): string =>
  Object.entries(suggestionsMap)
    // Longest key first: a key that prefixes another must not eat it.
    .sort(([keyA], [keyB]) => keyB.length - keyA.length)
    .reduce((subject, [key, value]) => subject.split(key).join(value), raw);

// The subject to write after the suggestions moved, or null to leave the
// field alone.
export const refreshedSubject = ({
  template,
  current,
  suggestionsMap,
}: {
  template: TemplateSubject | null;
  current: string;
  suggestionsMap: Record<string, string>;
}): string | null => {
  if (template == null || current !== template.applied) {
    return null;
  }
  const next = substituteSubject(template.raw, suggestionsMap);
  return next === current ? null : next;
};
